import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import UniComply_Header from "@components/UniComply_Header/UniComply_Header";
import UniComply_MainBody from "@components/UniComply_MainBody/UniComply_MainBody";
import UniComply_Features from "@components/UniComply_Features/UniComply_Features";
import UniComply_UseCases from "@components/UniComply_UseCases/UniComply_UseCases";
import UniComply_Guideline from "@components/UniComply_Guideline/UniComply_Guideline";
import UniComply_Pricing from "@components/UniComply_Pricing/UniComply_Pricing";
import UniComply_FAQ from "@components/UniComply_FAQ/UniComply_FAQ";
import UniComply_Contact from "@components/UniComply_Contact/UniComply_Contact";
import UniComply_Footer from "@components/UniComply_Footer/UniComply_Footer";
import CookieConsent from "@components/CookieConsent/CookieConsent";
import { CookieConsentManager, initializeTracking, disableTracking } from "@utils/cookieConsent";

export default function UniComply() {
  const location = useLocation();

  useEffect(() => {
    // Initialize tracking based on existing consent status
    const consentStatus = CookieConsentManager.getConsentStatus();
    if (consentStatus.status === "accepted") {
      initializeTracking();
    } else if (consentStatus.status === "declined") {
      disableTracking();
    }
  }, []);

  // Scroll to top or to features section when navigating from success page
  useEffect(() => {
    const state = location.state as { scrollToTop?: boolean; scrollToSection?: string } | null;
    if (!state) return;
    if (state.scrollToTop) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (state.scrollToSection === "features") {
      const el = document.getElementById("features");
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
      }
    }
  }, [location.state]);

  const handleAcceptCookies = () => {
    initializeTracking();
    console.log("User accepted cookies - tracking enabled");
  };

  const handleDeclineCookies = () => {
    disableTracking();
    console.log("User declined cookies - tracking disabled");
  };

  return (
    <Box sx={{ minHeight: "100vh", width: "100%", overflowX: "hidden" }}>
      {/* Header Section - Positioned absolutely over the hero section */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 20,
          width: "100%",
          padding: { xs: 0.5, md: 1 },
        }}
      >
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <UniComply_Header />
      </Box>

      {/* Hero Section with Background */}
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <UniComply_MainBody />
      {/* Features Section */}
      <Box id="features" component="section" sx={{ scrollMarginTop: 80 }}>
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <UniComply_Features />
      </Box>
      {/* Usecases Section */}
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <UniComply_UseCases />
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <UniComply_Guideline />
      {/* Usecases Pricing */}
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <UniComply_Pricing />
      {/* Usecases FAQ */}
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <UniComply_FAQ />
      {/* Usecases Contact */}
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <UniComply_Contact />
      {/* Usecases Footer*/}
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <UniComply_Footer />
      
      {/* Cookie Consent Popup */}
      <CookieConsent 
        onAccept={handleAcceptCookies}
        onDecline={handleDeclineCookies}
      />
      
      {/* Note: Additional sections (UseCase, Pricing, FAQ, Contact, Footer) 
          can be added here following the same pattern */}
    </Box>
  );
}
